import { AxiosResponse } from 'axios'

import { AxiosErrorResponseData, DataDomeError } from 'types/api'

export const isBlockedByDataDome = <T extends AxiosResponse<AxiosErrorResponseData<unknown>>>(
  headers: T['headers'],
  data: T['data'],
): data is DataDomeError => !!headers['x-dd-b'] && 'url' in data
